export const SemiProductSocketAssignment = (json: ISemiProductSocketAssignment): ISemiProductSocketAssignmentModel => {
	const { crm_semi_product_id, place_label, assigned_at, assigned_by, ...rest } = json

	return {
		...rest,
		id: crm_semi_product_id,
		placeLabel: place_label,
		assignedAt: assigned_at,
		assignedBy: assigned_by,
	}
}
